import { useGetPermissions } from 'layouts/customHook';
import React from 'react';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import ModuleCards from './moduleCards';

const RefundSetup=()=>{
    const userPermissions = useGetPermissions("refundSetup");
    return (
        userPermissions
            ? <ModuleCards/>
            : <PermisionDenied />
    );
}

export default RefundSetup
